import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * DesktopNav — md+ 에서만 표시되는 PC GNB 메뉴 (v2 목업 .gnb nav).
 *
 * 모바일: hidden (BottomNavigation 5탭이 대체)
 * 대표 결정 2026-09-21 #1: 목록 재공개 + 메뉴 5개.
 * 목업 메뉴(분양목록·지도·혜택특가·단지비교·분양뉴스) 중 '혜택특가'·'분양뉴스'는 라우트가 없어
 * 모바일 탭과 같은 목적지로 구성: 홈·분양목록·지도·단지비교·관심.
 * 스타일: 14px/600 slate(#334155), 활성 #FF6B00. (이전: 2026-05-24 '마이'만)
 */

const NAV_ITEMS = [
  { to: '/', label: '홈' },
  { to: '/list', label: '분양목록' },
  { to: '/map', label: '지도' },
  { to: '/compare', label: '단지비교' },
  { to: '/profile?tab=favorites', label: '관심' },
] as const;

const isActive = (pathname: string, search: string, to: string): boolean => {
  const [path, query] = to.split('?');
  if (path === '/') return pathname === '/';
  if (query) return pathname === path && search.includes(query);
  return pathname.startsWith(path);
};

export const DesktopNav: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { pathname, search } = useLocation();
  return (
    <nav
      className={`hidden md:flex md:items-center md:gap-6 ${className}`}
      aria-label="주요 메뉴"
    >
      {NAV_ITEMS.map((item) => {
        const active = isActive(pathname, search, item.to);
        return (
          <Link
            key={item.to}
            to={item.to}
            className={`inline-flex items-center whitespace-nowrap py-2 text-[14px] font-semibold transition-colors ${
              active ? 'text-accent' : 'text-body hover:text-ink'
            }`}
            aria-current={active ? 'page' : undefined}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
};

export default DesktopNav;
